/*
 * Plik: assets/mega-menu.js (Wersja OSTATECZNA FINALNA v3)
 * Wprowadza niezawodne zamykanie menu po kliknięciu poza jego obszarem.
 */
class MegaMenu {
  constructor(element) {
    this.container = element;
    this.trigger = this.container.querySelector('summary');
    this.panel = this.container.querySelector('.mega-menu__panel');
    this.detailsElement = this.trigger.closest('details');
    if (!this.trigger || !this.panel || !this.detailsElement) return;

    this.isAnimating = false;

    this.trigger.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.isAnimating) return;
      this.toggle();
    });

    // --- NOWA, POPRAWIONA LOGIKA ZAMYKANIA ---
    // Nasłuchujemy na kliknięcia w całym dokumencie.
    document.addEventListener('click', (event) => {
      // Sprawdzamy, czy menu jest otwarte ORAZ czy kliknięcie nastąpiło POZA kontenerem naszego menu
      if (this.detailsElement.hasAttribute('open') && !this.container.contains(event.target)) {
        if (this.isAnimating) return;
        this.close();
      }
    });
  }

  toggle() {
    if (this.detailsElement.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isAnimating = true;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    document.body.classList.add('mega-menu-open');
    this.detailsElement.setAttribute('open', '');
    
    requestAnimationFrame(() => {
        this.trigger.classList.add('mega-menu-summary--open');
        this.panel.classList.add('is-open');
        setTimeout(() => { this.isAnimating = false; }, 250);
    });
  }

  close() {
    this.isAnimating = true;
    this.trigger.classList.remove('mega-menu-summary--open');
    this.panel.classList.remove('is-open');

    setTimeout(() => {
        this.detailsElement.removeAttribute('open');
        document.body.classList.remove('mega-menu-open');
        document.documentElement.style.removeProperty('--scrollbar-width');
        this.isAnimating = false;
    }, 250);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const megaMenuElement = document.querySelector('mega-menu-component');
  if (megaMenuElement && window.matchMedia('(min-width: 990px)').matches) {
     new MegaMenu(megaMenuElement);
  }
});

if (typeof customElements.get('mega-menu-component') === 'undefined') {
  customElements.define('mega-menu-component', class extends HTMLElement {});
}